interface CrawlerSetting {
  defaultValue: boolean | string;
  name: string;
  text: string;
  options: {
    value: string;
    label: string;
  }[];
  helperText?: string;
  fullWidth?: boolean;
  disabled?: boolean;
}

interface CrawlerNumericSetting {
  defaultValue: number;
  name: string;
  text: string;
  tooltip?: string;
  min: number;
  max: number;
  measurement: string;
}

export const crawlerSetting: CrawlerSetting[] = [
  {
    defaultValue: 'host',
    name: 'domain_scope',
    text: 'محدوده دامنه',
    options: [
      { value: 'host', label: 'فقط هاست دقیق' },
      { value: 'root', label: 'دامنه ریشه (شامل زیردامنه‌ها)' }
    ]
  },
  {
    defaultValue: true,
    name: 'respect_robots_txt',
    text: 'رعایت فایل robots.txt',
    options: [
      { value: 'true', label: 'بله' },
      { value: 'false', label: 'خیر' }
    ]
  },
  {
    defaultValue: true,
    name: 'ignore_query',
    text: 'نادیده گرفتن پارامترهای نشانی',
    options: [
      { value: 'true', label: 'بله' },
      { value: 'false', label: 'خیر' }
    ],
    disabled: true
  },
  {
    defaultValue: true,
    name: 'ignore_rel_ahref_nofollow',
    text: 'نادیده گرفتن پیوندهای nofollow',
    options: [
      { value: 'true', label: 'بله' },
      { value: 'false', label: 'خیر' }
    ]
  },
  {
    defaultValue: true,
    name: 'ignore_fragment',
    text: 'نادیده گرفتن Fragment',
    options: [
      { value: 'true', label: 'بله' },
      { value: 'false', label: 'خیر' }
    ]
  },
  {
    defaultValue: false,
    name: 'respect_canonical',
    text: 'رعایت کنونیکال',
    options: [
      { value: 'true', label: 'بله' },
      { value: 'false', label: 'خیر' }
    ]
  },
  {
    defaultValue: false,
    name: 'respect_pagination',
    text: 'رعایت صفحه‌بندی',
    options: [
      { value: 'true', label: 'بله' },
      { value: 'false', label: 'خیر' }
    ]
  },
  {
    defaultValue: false,
    name: 'ignore_noindex_page',
    text: 'نادیده گرفتن صفحات noindex',
    options: [
      { value: 'true', label: 'بله' },
      { value: 'false', label: 'خیر' }
    ]
  },
  {
    defaultValue: false,
    name: 'custom_encoding_is_enable',
    text: 'رمزگذاری سفارشی',
    options: [
      { value: 'true', label: 'بله' },
      { value: 'false', label: 'خیر' }
    ]
  }
];

export const crawlerAssetSetting: CrawlerSetting[] = [
  {
    defaultValue: false,
    name: 'crawl_image_is_disable',
    text: 'غیرفعال کردن تصاویر',
    options: [
      { value: 'true', label: 'بله' },
      { value: 'false', label: 'خیر' }
    ]
  },
  {
    defaultValue: false,
    name: 'crawl_js_is_disable',
    text: 'غیرفعال کردن فایل‌های JS',
    options: [
      { value: 'true', label: 'بله' },
      { value: 'false', label: 'خیر' }
    ]
  },
  {
    defaultValue: false,
    name: 'crawl_css_is_disable',
    text: 'غیرفعال کردن فایل‌های CSS',
    options: [
      { value: 'true', label: 'بله' },
      { value: 'false', label: 'خیر' }
    ]
  }
];

// LIMIT SETTINGS
export const crawlerLimit: CrawlerNumericSetting[] = [
  {
    defaultValue: 10,
    name: 'depth_high',
    text: 'حداکثر عمق خزش',
    min: 0,
    max: 100,
    measurement: 'عمق'
  },
  {
    defaultValue: 10,
    name: 'redirect_max_times',
    text: 'حداکثر دنبال کردن تغییر مسیر',
    min: 0,
    max: 10,
    measurement: 'دنبال'
  },
  {
    defaultValue: 48,
    name: 'max_crawl_duration_hourly',
    text: 'حداکثر مدت خزش (ساعت)',
    min: 0,
    max: 96,
    measurement: 'ساعت'
  },
  {
    defaultValue: 15,
    name: 'bad_response_time',
    text: 'حداکثر زمان پاسخ',
    min: 0,
    max: 100,
    measurement: 'ثانیه'
  }
];
// SPEED SETTINGS
export const crawlerSpeed: CrawlerNumericSetting[] = [
  {
    defaultValue: 8,
    name: 'concurrent_requests',
    text: 'حداکثر سرعت خزش',
    min: 1,
    max: 15,
    measurement: 'درخواست'
  },
  {
    defaultValue: 2,
    name: 'download_delay',
    text: 'تأخیر دریافت منابع',
    min: 1,
    max: 100,
    measurement: 'ثانیه'
  }
];
// CONTENT SETTING
export const crawlerContent: CrawlerNumericSetting[] = [
  {
    defaultValue: 500,
    name: 'low_word',
    text: 'آستانه صفحات با محتوای کم',
    min: 100,
    max: 2000,
    measurement: 'کلمه'
  },
  {
    defaultValue: 4000,
    name: 'high_word',
    text: 'آستانه صفحات با محتوای زیاد',
    min: 1000,
    max: 10000,
    measurement: 'کلمه'
  },
  {
    defaultValue: 180,
    name: 'page_old_blog',
    text: 'حداکثر تعداد روز صفحات قدیمی آپدیت نشده',
    min: 1,
    max: 1000,
    measurement: 'روز'
  },
  {
    defaultValue: 5,
    name: 'page_low_unique_inline',
    text: 'آستانه صفحات تنها',
    min: 0,
    max: 100,
    measurement: 'پیوند داخلی'
  },
  {
    defaultValue: 15,
    name: 'page_high_unique_external_outline',
    text: 'آستانه صفحات با تعداد لینک خارجی',
    min: 0,
    max: 100,
    measurement: 'پیوند خارجی'
  },
  {
    defaultValue: 200,
    name: 'page_high_size',
    text: 'حداکثر اندازه صفحات سنگین',
    min: 100,
    max: 2000,
    measurement: 'کیلوبایت'
  },
  {
    defaultValue: 200,
    name: 'asset_high_size',
    text: 'حداکثر اندازه منابع سنگین',
    min: 100,
    max: 4000,
    measurement: 'کیلوبایت'
  },
  {
    defaultValue: 80,
    name: 'paragraph_similarity_percent',
    text: 'آستانه تکراری بودن متن صفحات',
    min: 0,
    max: 100,
    measurement: 'درصد'
  },
  {
    defaultValue: 80,
    name: 'title_similarity_percent',
    text: 'آستانه تکراری بودن عنوان صفحات',
    min: 0,
    max: 100,
    measurement: 'درصد'
  },
  {
    defaultValue: 60,
    name: 'title_char_is_long',
    text: 'آستانه عنوان طولانی (کاراکتر)',
    min: 1,
    max: 80,
    measurement: 'کاراکتر'
  },
  {
    defaultValue: 600,
    name: 'title_px_is_long',
    text: 'آستانه عنوان طولانی (کاراکتر)',
    min: 1,
    max: 8000,
    measurement: 'پیکسل'
  },
  {
    defaultValue: 20,
    name: 'title_char_is_short',
    text: 'آستانه عنوان کوتاه (کاراکتر)',
    min: 1,
    max: 80,
    measurement: 'کاراکتر'
  },
  {
    defaultValue: 300,
    name: 'title_px_is_short',
    text: 'آستانه عنوان کوتاه (پیگسل)',
    min: 1,
    max: 8000,
    measurement: 'کاراکتر'
  },
  {
    defaultValue: 160,
    name: 'meta_desc_char_is_long',
    text: 'آستانه توضیح متا طولانی (کاراکتر)',
    min: 1,
    max: 200,
    measurement: 'کاراکتر'
  },
  {
    defaultValue: 900,
    name: 'meta_desc_px_is_long',
    text: 'آستانه توضیح متا طولانی (پیکسل)',
    min: 1,
    max: 1200,
    measurement: 'پیکسل'
  },
  {
    defaultValue: 110,
    name: 'meta_desc_char_is_short',
    text: 'آستانه توضیح متا کوتاه (کاراکتر)',
    min: 1,
    max: 200,
    measurement: 'کاراکتر'
  },
  {
    defaultValue: 300,
    name: 'meta_desc_px_is_short',
    text: 'آستانه توضیح متا کوتاه (پیکسل)',
    min: 1,
    max: 1200,
    measurement: 'پیکسل'
  },
  {
    defaultValue: 80,
    name: 'density_percent',
    text: 'آستانه چگالی صفحات',
    min: 30,
    max: 100,
    measurement: 'درصد'
  }
];
